<template>
  <shipment-payment-confirmation-view
    class="shipment-payment-dialog-payment-confirmation-view"
    :shipment="shipment"
    @close="$emit('close')"
  />
</template>

<script>
  import ShipmentPaymentConfirmationView from '@/views/Shippers/components/ShipmentPaymentConfirmationView/index.vue'

  /**
   * @module component - ShipmentPaymentDialogPaymentConfirmationView
   * @param {object} shipment - The shipment object
   */
  export default {
    name: 'ShipmentPaymentDialogPaymentConfirmationView',
    components: {
      ShipmentPaymentConfirmationView
    },
    props: {
      shipment: {
        type: Object,
        default: null
      }
    }
  }
</script>
